function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScreenplifyLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 166 40",
    style: {
      enableBackground: "new 0 0 166 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_",
    className: "word"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    style: {
      fill: "#414242"
    },
    d: "M46.7,27.9v-1.2c1.2,0.5,2.8,0.8,4.7,0.8c1.4,0,2.5-0.3,3.4-1 c0.8-0.6,1.2-1.5,1.2-2.5c0-0.7-0.1-1.2-0.4-1.6c-0.3-0.4-0.7-0.8-1.3-1.2c-0.6-0.4-1.5-0.7-2.7-1.1c-1.8-0.6-3-1.3-3.6-2 c-0.7-0.7-1-1.6-1-2.8c0-1.3,0.5-2.3,1.5-3.1c1-0.8,2.3-1.2,3.9-1.2c1.6,0,3.1,0.3,4.5,0.9l-0.4,1c-1.4-0.6-2.8-0.9-4.1-0.9 c-1.3,0-2.3,0.3-3,0.9c-0.8,0.6-1.1,1.4-1.1,2.4c0,0.6,0.1,1.2,0.3,1.6c0.2,0.4,0.6,0.8,1.1,1.1c0.5,0.3,1.4,0.7,2.7,1.2 c1.3,0.5,2.3,0.9,3,1.3c0.7,0.4,1.2,0.9,1.5,1.5c0.3,0.6,0.5,1.2,0.5,2c0,1.4-0.5,2.6-1.6,3.4c-1.1,0.8-2.4,1.3-4.2,1.3 C49.5,28.6,47.9,28.3,46.7,27.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    style: {
      fill: "#414242"
    },
    d: "M60,22c0-2.1,0.5-3.8,1.6-4.9c1.1-1.2,2.5-1.8,4.4-1.8c1.1,0,2.2,0.2,3.2,0.6l-0.3,1 c-1.1-0.4-2.1-0.6-2.9-0.6c-1.6,0-2.8,0.5-3.6,1.5c-0.8,1-1.2,2.4-1.2,4.2c0,1.7,0.4,3.1,1.2,4.1c0.8,1,1.9,1.5,3.4,1.5 c1.2,0,2.2-0.2,3.2-0.6V28c-0.8,0.4-1.9,0.6-3.2,0.6c-1.8,0-3.3-0.6-4.3-1.7C60.5,25.7,60,24.1,60,22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    style: {
      fill: "#414242"
    },
    d: "M72.2,28.3V15.5h1l0.1,2.3h0.1c0.5-0.9,1.1-1.6,1.7-2c0.6-0.4,1.3-0.6,2.2-0.6 c0.5,0,1.1,0.1,1.7,0.2l-0.2,1.1c-0.5-0.1-1.1-0.2-1.7-0.2c-1.1,0-2,0.5-2.7,1.4c-0.7,0.9-1,2.1-1,3.5v7.1H72.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    style: {
      fill: "#414242"
    },
    d: "M80.8,22c0-2,0.5-3.7,1.5-4.9c1-1.2,2.4-1.8,4-1.8c1.5,0,2.7,0.5,3.6,1.6 c0.9,1.1,1.3,2.5,1.3,4.3v0.9H82c0,1.8,0.4,3.1,1.2,4c0.8,0.9,2,1.4,3.5,1.4c0.7,0,1.4-0.1,1.9-0.2c0.6-0.1,1.3-0.3,2.1-0.7v1.1 c-0.7,0.3-1.4,0.5-2,0.6c-0.6,0.1-1.3,0.2-2,0.2c-1.9,0-3.3-0.6-4.3-1.7C81.3,25.7,80.8,24.1,80.8,22z M82.1,21H90 c0-1.5-0.3-2.6-1-3.4c-0.6-0.8-1.5-1.2-2.7-1.2c-1.2,0-2.2,0.4-3,1.2C82.6,18.4,82.2,19.5,82.1,21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_19_",
    style: {
      fill: "#414242"
    },
    d: "M94,22c0-2,0.5-3.7,1.5-4.9c1-1.2,2.4-1.8,4-1.8c1.5,0,2.7,0.5,3.6,1.6 c0.9,1.1,1.3,2.5,1.3,4.3v0.9h-9.2c0,1.8,0.4,3.1,1.2,4c0.8,0.9,2,1.4,3.5,1.4c0.7,0,1.4-0.1,1.9-0.2c0.6-0.1,1.3-0.3,2.1-0.7v1.1 c-0.7,0.3-1.4,0.5-2,0.6c-0.6,0.1-1.3,0.2-2,0.2c-1.9,0-3.3-0.6-4.3-1.7C94.5,25.7,94,24.1,94,22z M95.3,21h7.9 c0-1.5-0.3-2.6-1-3.4c-0.6-0.8-1.5-1.2-2.7-1.2c-1.2,0-2.2,0.4-3,1.2C95.8,18.4,95.4,19.5,95.3,21z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_43_",
    style: {
      fill: "#414242"
    },
    d: "M108,28.3V15.5h1l0.2,1.8h0.1c0.8-1.3,2.3-2,4.4-2c2.9,0,4.4,1.6,4.4,4.7v8.4h-1.2 V20c0-1.3-0.3-2.2-0.8-2.8c-0.5-0.6-1.4-0.9-2.5-0.9c-1.5,0-2.7,0.4-3.4,1.2c-0.7,0.8-1.1,2-1.1,3.8v7.1H108z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_45_",
    style: {
      fill: "#414242"
    },
    d: "M122.2,34.1V15.5h1l0.2,1.8h0.1c0.9-1.4,2.3-2.1,4.2-2.1c1.7,0,3.1,0.6,4,1.7 c0.9,1.1,1.4,2.8,1.4,4.9c0,2.1-0.5,3.7-1.4,4.9c-1,1.2-2.3,1.7-3.9,1.7c-2,0-3.4-0.7-4.3-2.2h-0.1l0,1c0,0.6,0,1.2,0,1.9v4.9 H122.2z M123.4,22c0,2,0.3,3.4,1,4.3c0.7,0.9,1.8,1.3,3.3,1.3c1.3,0,2.3-0.5,3-1.5c0.7-1,1.1-2.3,1.1-4.1c0-3.7-1.4-5.6-4.1-5.6 c-1.5,0-2.6,0.4-3.3,1.2c-0.7,0.8-1,2.2-1,4V22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_48_",
    style: {
      fill: "#414242"
    },
    d: "M136.5,28.3V10h1.2v18.3H136.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_50_",
    style: {
      fill: "#414242"
    },
    d: "M141.8,12c0-0.8,0.2-1.1,0.6-1.1c0.3,0,0.5,0.1,0.6,0.3c0.2,0.2,0.2,0.5,0.2,0.8 c0,0.4-0.1,0.6-0.2,0.8c-0.2,0.2-0.4,0.3-0.6,0.3C142,13.1,141.8,12.8,141.8,12z M142,28.3V15.5h1v12.8H142z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_53_",
    style: {
      fill: "#414242"
    },
    d: "M145.6,16.6v-0.7l2.4-0.4v-1c0-1.6,0.3-2.7,0.9-3.5c0.6-0.7,1.5-1.1,2.8-1.1 c0.7,0,1.4,0.1,2.1,0.3l-0.3,1c-0.6-0.2-1.3-0.3-1.9-0.3c-0.9,0-1.6,0.3-1.9,0.8c-0.4,0.5-0.6,1.4-0.6,2.6v1.2h3v1h-3v11.8H148 V16.6H145.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_55_",
    style: {
      fill: "#414242"
    },
    d: "M152.5,15.5h1.2l2.7,7.2c0.8,2.2,1.3,3.7,1.6,4.5h0.1c0.3-1,0.9-2.5,1.6-4.5l2.7-7.1 h1.2l-5.7,14.9c-0.5,1.2-0.9,2-1.2,2.4c-0.3,0.4-0.7,0.7-1.1,1c-0.4,0.2-0.9,0.3-1.5,0.3c-0.4,0-0.9-0.1-1.5-0.2v-1 c0.5,0.1,0.9,0.2,1.5,0.2c0.4,0,0.8-0.1,1.1-0.3c0.3-0.2,0.6-0.5,0.8-0.9c0.2-0.4,0.5-1,0.9-1.9c0.3-0.9,0.5-1.4,0.6-1.7 L152.5,15.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3_",
    className: "donut"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_26_",
    style: {
      fill: "#92C547"
    },
    points: "14.5,20.6 4.2,26.6 14.5,32.6  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_23_",
    style: {
      fill: "#FED725"
    },
    d: "M3.1,26V14l10.4,6L3.1,26"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_20_",
    style: {
      fill: "#E33092"
    },
    points: "15.2,7.4 25.5,13.4 15.2,19.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_17_",
    style: {
      fill: "#AD2388"
    },
    points: "25.5,14 15.2,20 25.5,26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_14_",
    style: {
      fill: "#DD1F28"
    },
    points: "4.2,0.9 14.5,6.9 4.2,12.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_11_",
    style: {
      fill: "#ED6F27"
    },
    points: "14.5,7.4 4.2,13.4 14.5,19.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_8_",
    style: {
      fill: "#F283B4"
    },
    points: "26.1,14 36.5,20 26.1,26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_5_",
    style: {
      fill: "#2095CF"
    },
    points: "15.2,32.6 25.5,26.6 15.2,20.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2_",
    style: {
      fill: "#68CBE1"
    },
    points: "4.2,39.1 14.5,33.1 4.2,27.2  "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenplifyLogo);
export default __webpack_public_path__ + "static/media/screenplify_logo.711c55ca.svg";
export { ForwardRef as ReactComponent };